import { ColumnMetadata, DataGrid, RowSizes } from "~/components/DataGrid";
import { PaginationState, SortQuery } from "~/modules/filters/types";
import { AssetTableRowData } from "./types";
import { Asset, AssetColumns } from "~/modules/assets/types";
import { useInMemoryAssetSort } from "./useInMemoryAssetSort";
import { AssetTableRow } from "./AssetTableRow";

// // // //

export function AssetTableLocal(props: {
    rows: Asset[];
    columns: ColumnMetadata<Asset, AssetColumns>[];
    size?: RowSizes;
    paginationState?: PaginationState;
    analyticsTableName: string;
    defaultExpandedState?: boolean;
    enableScrollButton?: boolean;
    onSelectAsset?: (_selected: Asset) => void;
    sortQuery?: SortQuery;
    flush?: boolean;
    bordered?: boolean;
    striped?: boolean;
    fixedHeader?: boolean;
    showHeader?: boolean;
    includeAdditionalNetworksRow?: boolean;
}) {
    const {
        columns,
        rows,
        size = RowSizes.small,
        paginationState,
        analyticsTableName,
        defaultExpandedState = false,
        enableScrollButton,
        sortQuery,
        flush,
        bordered = true,
        striped = true,
        fixedHeader = true,
        showHeader = true,
        includeAdditionalNetworksRow = true,
    } = props;

    const { query, setQuery, sortedItems } = useInMemoryAssetSort({
        rows,
        sort: sortQuery,
    });

    return (
        <DataGrid
            query={query}
            columns={columns}
            rows={sortedItems}
            rowKey="id"
            bordered={bordered}
            size={size}
            loading={false}
            fixedHeader={fixedHeader}
            analyticsTableName={analyticsTableName}
            paginationState={paginationState}
            onChangeQuery={setQuery}
            enableItemsPerPageSelect
            enableScrollButton={enableScrollButton}
            flush={flush}
            showHeader={showHeader}
        >
            {({ row, rowIndex, scrollLeft }) => (
                <AssetTableRow
                    asset={row}
                    size={size}
                    columns={
                        columns as ColumnMetadata<
                            AssetTableRowData,
                            AssetColumns
                        >[]
                    }
                    rowIndex={rowIndex}
                    scrollLeft={scrollLeft}
                    bordered={bordered}
                    defaultExpandedState={defaultExpandedState}
                    striped={striped}
                    includeAdditionalNetworksRow={includeAdditionalNetworksRow}
                    // onSelect={() => {
                    //     Analytics.trackOpenProductDetails({
                    //         assetName: row.name,
                    //     });
                    //     setSelectedProduct(row as Asset);
                    //     setOpenDetails(true);
                    // }}
                />
            )}
        </DataGrid>
    );
}
